import React from 'react';

import { SvgIcon, SvgIconProps } from '@mui/material';

const Ratio2: React.FC<SvgIconProps> = (props) => {
  return (
    <SvgIcon {...props}>
      <rect
        width="2"
        height="4"
        transform="matrix(2.18557e-08 -1 -1 -8.74228e-08 23 3)"
        fillOpacity="0.87"
      />
      <rect
        width="2"
        height="4"
        transform="matrix(1 6.55671e-08 1.31134e-07 -1 21 5)"
        fillOpacity="0.87"
      />
      <rect
        width="2"
        height="4"
        transform="matrix(1 6.55671e-08 1.31134e-07 -1 21 23)"
        fillOpacity="0.87"
      />
      <rect
        width="2"
        height="4"
        transform="matrix(-1.09278e-07 1 1 1.74846e-07 19 21)"
        fillOpacity="0.87"
      />
      <rect
        width="2"
        height="4"
        transform="matrix(2.18557e-08 -1 -1 -8.74228e-08 23 3)"
        fillOpacity="0.87"
      />
      <rect
        width="2"
        height="4"
        transform="matrix(1 6.55671e-08 1.31134e-07 -1 21 5)"
        fillOpacity="0.87"
      />
      <rect
        width="2"
        height="4"
        transform="matrix(1 6.55671e-08 1.31134e-07 -1 21 23)"
        fillOpacity="0.87"
      />
      <rect
        width="2"
        height="4"
        transform="matrix(-1.09278e-07 1 1 1.74846e-07 19 21)"
        fillOpacity="0.87"
      />
      <rect
        x="1"
        y="3"
        width="2"
        height="4"
        transform="rotate(-90 1 3)"
        fillOpacity="0.87"
      />
      <rect
        x="3"
        y="5"
        width="2"
        height="4"
        transform="rotate(180 3 5)"
        fillOpacity="0.87"
      />
      <rect
        x="3"
        y="23"
        width="2"
        height="4"
        transform="rotate(180 3 23)"
        fillOpacity="0.87"
      />
      <rect
        x="5"
        y="21"
        width="2"
        height="4"
        transform="rotate(90 5 21)"
        fillOpacity="0.87"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M17 7H7V17H17V7ZM5 5V19H19V5H5Z"
        fillOpacity="0.87"
      />
    </SvgIcon>
  );
};

export default Ratio2;
